import { IDropdownOptions } from "@poste-click-connect/shared-ui"

export const generalStateDropdownOption: IDropdownOptions<string>[] = [
    {id: '', label: '', payload: ''},
    {id: '1', label: 'OK', payload: 'OK'},
    {id: '2', label: 'KO', payload: 'KO'},
    {id: '3', label: 'IN VALUTAZIONE', payload: 'IN VALUTAZIONE'},
    {id: '4', label: 'NON DOVUTA', payload: 'NON DOVUTA'}
]

export const operazioneDropdownOption: IDropdownOptions<string>[] = [
    {id: '', label: '', payload: ''},
    {id: '1', label: 'Nuovo Inserimento', payload: 'N'},
    {id: '2', label: 'Modifica Indirizzo', payload: 'I'},
    {id: '3', label: 'Variazione', payload: 'V'},
    {id: '4', label: 'Subentro', payload: 'S'},
    {id: '5', label: 'Recesso', payload: 'D'},
    {id: '6', label: 'Ripresa Dati', payload: 'U'}
];

export const operazioneLockerDropdownOption: IDropdownOptions<string>[] = [
    {id: '', label: '', payload: ''},
    {id: '1', label: 'Modifica Indirizzo', payload: 'I'},
    {id: '2', label: 'Variazione', payload: 'V'},
    {id: '3', label: 'Recesso', payload: 'D'},
];

export const operazioneLockerDropdownOptionUserAPT: IDropdownOptions<string>[] = [
    {id: '', label: '', payload: ''},
    {id: '1', label: 'Nuovo Inserimento', payload: 'N'},
    {id: '2', label: 'Modifica Indirizzo', payload: 'I'},
    {id: '3', label: 'Variazione', payload: 'V'},
    {id: '4', label: 'Recesso', payload: 'D'},
];
